// extracted by mini-css-extract-plugin
export default {"container":"_a64af95f"};